<template>
  <button
    v-if="handle"
    @click="changeProductByHandle({ handle, metafields })"
  >
    <slot />
  </button>
  <button
    v-else
    @click="openSlideout"
  >
    <slot />
  </button>
</template>

<script>
import { useVariantCollectionStore } from '../../pinia/VariantCollectionStore'
import { useProductStore } from '../../pinia/ProductStore'
import { mapActions } from 'pinia'

export default {
  props: {
    handle: {
      type: String,
      default: null
    },
    metafields: {
      type: Object,
      default: null
    }
  },
  methods: {
    ...mapActions(useVariantCollectionStore, [
      'openSlideout'
    ]),
    ...mapActions(useProductStore, [
      'changeProductByHandle'
    ]),
  }
}
</script>
